export const PUBLIC_CSV_DEMO_ANALYSIS_KEY = 'finnixpro:publicCsvDemoAnalysis:v1';
export const PUBLIC_CSV_DEMO_SAMPLE_KEY = 'finnixpro:publicCsvDemoSample:v1';
const ACTIVE_SOURCE_KEY = 'finnixpro:publicCsvDemoSource:v1';
const PENDING_SOURCE_KEY = 'finnixpro:publicCsvDemoPendingSource:v1';
export const PUBLIC_CSV_DEMO_PENDING_REVIEW_KEY = 'finnixpro:publicCsvDemoPendingReview:v1';
export const PUBLIC_CSV_DEMO_STATE_TTL_MS = 60 * 60 * 1000;

// Storage can be unavailable in restricted browsers or full after a large demo upload.
const storage = {
  getItem: key => { try { return window.sessionStorage.getItem(key); } catch { return null; } },
  setItem: (key, value) => { try { window.sessionStorage.setItem(key, value); } catch { /* Current review remains usable. */ } },
  removeItem: key => { try { window.sessionStorage.removeItem(key); } catch { /* Nothing to clear. */ } },
};

export const getPublicCsvDemoReturnState = (email) => ({
  ...(email ? { email } : {}),
  demoAnalysisReturn: true,
  from: { pathname: '/resources/demo' },
});

export const getPublicCsvDemoSource = () => storage.getItem(ACTIVE_SOURCE_KEY) === 'sample' ? 'sample' : 'upload';
export const setPublicCsvDemoSource = source => storage.setItem(ACTIVE_SOURCE_KEY, source === 'sample' ? 'sample' : 'upload');
export const getPendingPublicCsvDemoSource = () => storage.getItem(PENDING_SOURCE_KEY) === 'sample' ? 'sample' : 'upload';

export const markPublicCsvDemoPendingReview = (source = getPublicCsvDemoSource()) => {
  storage.setItem(PENDING_SOURCE_KEY, source);
  storage.setItem(PUBLIC_CSV_DEMO_PENDING_REVIEW_KEY, 'true');
};

export const hasPublicCsvDemoPendingReview = () => (
  storage.getItem(PUBLIC_CSV_DEMO_PENDING_REVIEW_KEY) === 'true'
);

export const clearPublicCsvDemoPendingReview = () => {
  storage.removeItem(PUBLIC_CSV_DEMO_PENDING_REVIEW_KEY);
  storage.removeItem(PENDING_SOURCE_KEY);
};

export const savePublicCsvDemoAnalysis = ({ fileName, projects, source = 'upload' }) => {
  setPublicCsvDemoSource(source);
  storage.setItem(source === 'sample' ? PUBLIC_CSV_DEMO_SAMPLE_KEY : PUBLIC_CSV_DEMO_ANALYSIS_KEY, JSON.stringify({
    version: 1,
    createdAt: Date.now(),
    fileName,
    projects,
  }));
};

export const loadPublicCsvDemoAnalysis = (source = 'upload') => {
  const key = source === 'sample' ? PUBLIC_CSV_DEMO_SAMPLE_KEY : PUBLIC_CSV_DEMO_ANALYSIS_KEY;
  const stored = storage.getItem(key);
  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored);
    const isExpired = !parsed.createdAt || Date.now() - parsed.createdAt > PUBLIC_CSV_DEMO_STATE_TTL_MS;
    const isInvalid = parsed.version !== 1 || !Array.isArray(parsed.projects) || !parsed.projects.length;
    if (isExpired || isInvalid) {
      storage.removeItem(key);
      if (getPendingPublicCsvDemoSource() === source) clearPublicCsvDemoPendingReview();
      return null;
    }
    return parsed;
  } catch (_error) {
    storage.removeItem(key);
    if (getPendingPublicCsvDemoSource() === source) clearPublicCsvDemoPendingReview();
    return null;
  }
};

export const clearPublicCsvDemoAnalysis = (source = 'upload') => {
  storage.removeItem(source === 'sample' ? PUBLIC_CSV_DEMO_SAMPLE_KEY : PUBLIC_CSV_DEMO_ANALYSIS_KEY);
  clearPublicCsvDemoPendingReview();
};

export const preservePublicCsvDemoContext = () => {
  const source = getPublicCsvDemoSource();
  if (loadPublicCsvDemoAnalysis(source)) markPublicCsvDemoPendingReview(source);
};
